import { stringify } from 'query-string';
import { BASE_V2_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'BLOCK_GET',
  GET_SUCCESS: 'BLOCK_GET_SUCCESS',
  GET_FAILURE: 'BLOCK_GET_FAILURE',
  INVALIDATE_ITEM: 'BLOCK_INVALIDATE_ITEM',
  GET_ALL: 'BLOCK_GET_ALL',
  GET_ALL_SUCCESS: 'BLOCK_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'BLOCK_GET_ALL_FAILURE',
  POST: 'BLOCK_POST',
  POST_SUCCESS: 'BLOCK_POST_SUCCESS',
  POST_FAILURE: 'BLOCK_POST_FAILURE',
  PATCH: 'BLOCK_PATCH',
  PATCH_SUCCESS: 'BLOCK_PATCH_SUCCESS',
  PATCH_FAILURE: 'BLOCK_PATCH_FAILURE',
};

export const get = actions.get(blockTagId => `${BASE_V2_URL}/block/${blockTagId}/`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};

export const getAll = actions.getAll(
  query => `${BASE_V2_URL}/blocks/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const post = actions.post((id, value) => `${BASE_V2_URL}/blocks/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const patch = actions.patch(blockId => `${BASE_V2_URL}/block/${blockId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
